import { AlternatePayeeApiConfig, FetchParams } from '../../../types'

const buildRequestParams = async (
  config: AlternatePayeeApiConfig,
  method: 'GET' | 'POST' | 'PUT',
  data?: string
): Promise<FetchParams> => {
  const finalUrl = `${config.baseUrl}${config.path}`
  const url = new URL(finalUrl);

  let token = '';
  try {
    token = await config.getBearerToken();
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    console.warn('Failed to retrieve bearer token:', errorMessage);
    token = '';
  }

  const init: RequestInit = {
    method,
    body: data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };

  return { url, init };
};


export const alternatePayeeApi = {

  get: async (config: AlternatePayeeApiConfig): Promise<Response> => {
    const params = await buildRequestParams(config, 'GET');
    return fetch(params.url, params.init);
  },

  post: async (config: AlternatePayeeApiConfig, data: string): Promise<Response> => {
    const params = await buildRequestParams(config, 'POST', data);
    return fetch(params.url, params.init);
  },

  put: async (config: AlternatePayeeApiConfig, data: string): Promise<Response> => {
    const params = await buildRequestParams(config, 'PUT', data);
    return fetch(params.url, params.init);
  }
};